import { Component, ChangeDetectionStrategy, ElementRef, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogFullScreenComponentContent } from '../../../models/dialogs/dialog-full-screen';
import { environment } from '../../../../src/environments/environment'

@Component({
    selector: 'pi-new-password-email-successfully-sent',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './pi-new-password-email-successfully-sent.component.html',
    styleUrls: ['./pi-new-password-email-successfully-sent.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
})
export class PiNewPasswordEmailSuccessfullySent extends DialogFullScreenComponentContent {
    public isNewBrand: boolean = environment.isNewBrand
    constructor(
        element: ElementRef,
        private dialogReference: MatDialogRef<PiNewPasswordEmailSuccessfullySent>,
    ) {
        super(element);
    }
    public dispose() {
        super.close(this.dialogReference, null);
    }
}
